module.exports = "<div class=\"alltag <% if(selected){  print(selectedClassName)}%>\" id=\"<%= tagId %>\">\n\t#<%= label %> \n</div>\n"